/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {getError, getResponseError} from "../../helper/handlingError";
import ApiBaseUrl from "../../baseUrl";
import {
    REQUEST_ADD_USER,
    REQUEST_ADD_USER_FAILURE,
    REQUEST_ADD_USER_SUCCESS,
    REQUEST_DELETE_USER,
    REQUEST_DELETE_USER_FAILURE,
    REQUEST_DELETE_USER_SUCCESS,
    REQUEST_FORGOT_PASSWORD,
    REQUEST_FORGOT_PASSWORD_FAILURE,
    REQUEST_FORGOT_PASSWORD_SUCCESS,
    REQUEST_RESET_PASSWORD_USER,
    REQUEST_RESET_PASSWORD_USER_FAILURE,
    REQUEST_RESET_PASSWORD_USER_SUCCESS,
    REQUEST_UPDATE_USER,
    REQUEST_UPDATE_USER_FAILURE,
    REQUEST_UPDATE_USER_SUCCESS,
    REQUEST_USER,
    REQUEST_USER_FAILURE,
    REQUEST_USER_SUCCESS,
    REQUEST_USERS,
    REQUEST_USERS_FAILURE,
    REQUEST_USERS_SUCCESS
} from "../../constant/UsersConstant";

export const fetchAllUsersAction = (requestParam) => async (dispatch) => {

    dispatch({
        type: REQUEST_USERS
    })

    try {
        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'GET',
            params: requestParam,
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            data: {},
            url: `/api/v1/users`,
        });

        if (status === 200) {
            dispatch({
                type: REQUEST_USERS_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch (error) {
        dispatch({
            type: REQUEST_USERS_FAILURE,
        });
        await getError(error);
    }
}

export const fetchAddUsersAction = (requestParam) => async (dispatch) => {

    dispatch({
        type: REQUEST_ADD_USER
    })

    try {
        const formData = new FormData();
        formData.append('image', requestParam.image);
        formData.append('email', requestParam.email);
        formData.append('phone', requestParam.phone);
        formData.append('full_name', requestParam.full_name);
        formData.append('password', requestParam.password);
        formData.append('isActive', requestParam.isActive);
        formData.append('scope', requestParam.scope);
        formData.append('status', requestParam.status);

        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'POST',
            params: {},
            headers: {
                'Content-Type': 'application/form-data',
                Authorization: `Bearer ${token}`
            },
            data: formData,
            url: `/api/v1/users`,
        });

        if (data.result === null) {
            await getResponseError(data.responseData.message.email);
        }
        if (status === 200) {
            dispatch({
                type: REQUEST_ADD_USER_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch
        (error) {
        dispatch({
            type: REQUEST_ADD_USER_FAILURE,
        });
    }
}

export const fetchUsersAction = (id) => async (dispatch) => {

    dispatch({
        type: REQUEST_USER
    })

    try {
        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'GET',
            params: {},
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            data: {},
            url: `/api/v1/users/${id}`,
        });

        if (data.result === null) {
            await getResponseError(data.responseData.message);
        }
        if (status === 200) {
            dispatch({
                type: REQUEST_USER_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch
        (error) {
        dispatch({
            type: REQUEST_USER_FAILURE,
        });
        await getError(error);
    }
}

export const fetchUpdateUsersAction = (id, requestParam) => async (dispatch) => {

    dispatch({
        type: REQUEST_UPDATE_USER
    })

    try {
        const formData = new FormData();
        formData.append('image', requestParam.image);
        formData.append('email', requestParam.email);
        formData.append('full_name', requestParam.full_name);
        formData.append('isActive', requestParam.isActive);
        formData.append('scope', requestParam.scope);
        formData.append('isMobile', requestParam.isMobile);
        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'POST',
            params: {},
            headers: {
                'Content-Type': 'application/form-data',
                Authorization: `Bearer ${token}`
            },
            data: formData,
            url: `/api/v1/users/update/${id}`,
        });

        if (data.result === null) {
            await getResponseError(data.responseData.message);
        }
        if (status === 200) {
            dispatch({
                type: REQUEST_UPDATE_USER_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch
        (error) {
        dispatch({
            type: REQUEST_UPDATE_USER_FAILURE,
        });
        await getError(error);
    }
}

export const fetchDeleteUsersAction = (id) => async (dispatch) => {

    dispatch({
        type: REQUEST_DELETE_USER
    })

    try {
        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'DELETE',
            params: {},
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            data: {},
            url: `/api/v1/users/${id}`,
        });

        if (status === 200) {
            dispatch({
                type: REQUEST_DELETE_USER_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch
        (error) {
        dispatch({
            type: REQUEST_DELETE_USER_FAILURE,
        });
        await getError(error);
    }
}

export const fetchResetPasswordUsersAction = (requestParam) => async (dispatch) => {

    dispatch({
        type: REQUEST_RESET_PASSWORD_USER
    })

    try {
        const token = localStorage.getItem('session') && JSON.parse(localStorage.getItem('session')).session.access_token;
        const {data, status} = await ApiBaseUrl({
            method: 'POST',
            params: {},
            headers: {
                'Content-type': 'application/json',
                Authorization: `Bearer ${token}`
            },
            data: requestParam,
            url: `/api/reset-password`,
        });

        if (status === 200) {
            dispatch({
                type: REQUEST_RESET_PASSWORD_USER_SUCCESS,
                payload: data,
            });
            return data;
        }
    } catch
        (error) {
        dispatch({
            type: REQUEST_RESET_PASSWORD_USER_FAILURE,
        });
        await getError(error);
    }
}


export const fetchForgotPassword = (userObj) => async (dispatch) => {
   // console.log(userObj)
    dispatch({
        type: REQUEST_FORGOT_PASSWORD
    })

    try {
        const {data, status} = await ApiBaseUrl({
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            data: userObj,
            url: "/api/forgot-password"
        })

        if (status === 200) {
            dispatch({
                type: REQUEST_FORGOT_PASSWORD_SUCCESS,
                data: data
            })
            return data;
        }
    } catch (error) {
        dispatch({
            type: REQUEST_FORGOT_PASSWORD_FAILURE
        })
    }
}

export const fetchVerifyForgotPasswordUsersAction = (forgotPassword) => async (dispatch) => {
   // console.log(forgotPassword)
    dispatch({
        type: REQUEST_FORGOT_PASSWORD
    })

    try {
        const {data, status} = await ApiBaseUrl({
            method: 'POST',
            headers: {
                'Content-type': 'application/json',
            },
            data: forgotPassword,
            url: "/api/verify-forgot-password"
        })

        if (status === 200) {
            dispatch({
                type: REQUEST_FORGOT_PASSWORD_SUCCESS,
                data: data
            })
            return data;
        }
    } catch (error) {
        dispatch({
            type: REQUEST_FORGOT_PASSWORD_FAILURE
        })
    }
}
